import { FC, useState } from "react";
import BluePlayerDancing from "../../../assets/avatars/avatarsDancingPodium/Blue_Player_Podium_min.png";
import GreenPlayerDancing from "../../../assets/avatars/avatarsDancingPodium/Green_Player_Podium_min.png";
import PinkPlayerDancing from "../../../assets/avatars/avatarsDancingPodium/Pink_Player_Podium_min.png";
import YellowPlayerDancing from "../../../assets/avatars/avatarsDancingPodium/Yellow_Player_Podium_min.png";

import "./DancingAvatar.scss";

interface IAvatarProps {
    icon?: any;
    place: any;
    color: any;
    placeOnPodium: string;
}

const DancingAvatar: FC<IAvatarProps> = (props) => {
    const { icon, place, color, placeOnPodium } = props;

    const [playerSize, setPlayerSize] = useState(window.innerWidth / 1800);

    const changePlayerSize = () => {
        setPlayerSize(window.innerWidth / 1800)
    }

    window.addEventListener('resize', changePlayerSize);

    function setColor(): any {
        if (color === "blue")
            return "#3AC1CC";
        if (color === "yellow")
            return "#FFD200";
        if (color === "green")
            return "#51BD8A";
        if (color === "pink")
            return "#EB078A";

        return "#EB078A";
    }

    const getAvatarByPlayerColor = () => {
        if (color === "blue")
            return BluePlayerDancing;
        if (color === "yellow")
            return YellowPlayerDancing;
        if (color === "green")
            return GreenPlayerDancing;
        if (color === "pink")
            return PinkPlayerDancing;

        return PinkPlayerDancing;
    }

    return (
        <div className="podium_player_container">
            <div className="podium_avatar_container">
                <div className="podium_place_avatar" style={{ transform: `scale(${playerSize})` }}>
                    <img className="cheering" src={getAvatarByPlayerColor()} alt="" />
                </div>
            </div>
            <div style={{ backgroundColor: `${setColor()}`, height: `${30-parseInt(place)*5}vh` }} className={placeOnPodium}>
                <div className="icon_container">
                    {!!icon && <img src={icon} alt="" />}
                </div>
                <p>{place}</p>
            </div>
        </div>
    )
};

export default DancingAvatar;